export enum ECompletionYearType {
  HandedOver = 'handedOver',
  CurrentYear = 0,
  InOneYear = 1,
  InTwoYears = 2,
  InThreeYears = 3,
  Later = 4,
}

export const AVAILABLE_COMPLETION_YEAR_TYPES = [
  ECompletionYearType.CurrentYear,
  ECompletionYearType.InOneYear,
  ECompletionYearType.InTwoYears,
  ECompletionYearType.InThreeYears,
];

export const CURRENT_YEAR = new Date().getFullYear();
